export default __webpack_public_path__ + "static/media/knot.505b5c01.png";